import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/showSessionAIMsg/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showSessionAIMsgSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showSessionAIMsgSelector };
